<template>
    <div>

    <!--content Start -->
    <div class="content" id="top">
        <!--Banner Start Here -->
        <section class="banner">
            <div class="container clearfix">
                <div class="banner__caption">
                    <h1>{{$t('Home.bloc1.title')}}</h1><br>
                    <p>
                        {{$t('Home.bloc1.content1')}}
                    </p>
                    <p>
                        {{$t('Home.bloc1.content2')}}
                    </p>
                    <p>
                        {{$t('Home.bloc1.content3')}}
                    </p>
                    <p>
                        {{$t('Home.bloc1.content5')}}
                    </p>
                    <a href="https://itunes.apple.com/us/app/chaperon/id1366598828?ls=1&mt=8" target="_blank" alt="Chaperon apple store" v-bind:title="$t('Home.bloc1.downloadiOs')"> <img src="static/img/app-store.png" alt="" class="button"/> </a>
                    <a href="https://play.google.com/store/apps/details?id=com.pandaaz.chaperon" target="_blank" alt="Chaperon play store" v-bind:title="$t('Home.bloc1.downloadAndroid')"> <img src="static/img/g-play.png" alt="" class="button"/> </a>
                    <p>
                        {{$t('Home.bloc1.content4')}}
                    </p>
                </div>
                <div class="banner__phone">
                    <img src="static/img/iphone.png" alt="" />
                </div>
            </div>
        </section>
        <!--Banner End Here -->
        <!--Section Intro Start Here -->
        <section class="section-intro" id="intro">
            <div  class="container" >
                <div class="row">
                    <div class="col-sm-6">
                        <div class="section-intro__img">
                            <img src="static/img/ui_screens.png" alt="" />
                        </div>
                    </div>
                    <div class="col-sm-6 text-center">
                        <div class="section-intro__text">
                            <h2>{{$t('Home.bloc2.title')}}</h2>
                            <p>
                                <strong>{{$t('Home.bloc2.name')}}</strong>
                                <br />
                                <span>{{$t('Home.bloc2.def')}}</span>
                            </p>
                            <p>
                                {{$t('Home.bloc2.content1')}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Section Intro End Here -->
        <!--Section Desc Start Here -->
        <section class="section-desc text-center">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 section-desc__caption">
                        <h2>{{$t('Home.bloc3.title')}}</h2>
                        <p>
                            {{$t('Home.bloc3.content1')}}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="section-desc__block">
                            <span class="section-desc__title"> <i class="sprite-chaperon">&nbsp;</i> Chaperon</span>
                            <p>
                                {{$t('Home.bloc3.chaperon-header')}}
                            </p>
                            <ul>
                                <li>
                                    <i class="sprite-couple">&nbsp;</i>
                                    <h4>{{$t('Home.bloc3.chaperon-block1-title')}}</h4>
                                    <p>
                                       {{$t('Home.bloc3.chaperon-block1-content')}}
                                    </p>
                                </li>
                                <li>
                                    <i class="sprite-point">&nbsp;</i>
                                    <h4>{{$t('Home.bloc3.chaperon-block2-title')}}</h4>
                                    <p>
                                        {{$t('Home.bloc3.chaperon-block2-content')}}
                                    </p>
                                </li>
                                <li>
                                    <i class="sprite-excng">&nbsp;</i>
                                    <h4>{{$t('Home.bloc3.chaperon-block3-title')}}</h4>
                                    <p>
                                        {{$t('Home.bloc3.chaperon-block3-content')}}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="section-desc__block section-desc__block--modifier">
                            <span class="section-desc__title section-desc__title--modifier"> <i class="sprite-bachelor">&nbsp;</i> Chappy</span>
                            <p>
                                {{$t('Home.bloc3.chappy-header')}}
                            </p>
                            <ul>
                                <li>
                                    <img src="static/img/img-prediction.png" class="img-prediction">
                                    <h4>{{$t('Home.bloc3.chappy-block1-title')}}</h4>
                                    <p>
                                        {{$t('Home.bloc3.chappy-block1-content')}}
                                    </p>
                                </li>
                                <li>
                                    <i class="sprite-bot">&nbsp;</i>
                                    <h4>{{$t('Home.bloc3.chappy-block2-title')}}</h4>
                                    <p>
                                        {{$t('Home.bloc3.chappy-block2-content')}}
                                    </p>
                                </li>
                                <li>
                                    <i class="sprite-evaluat">&nbsp;</i>
                                    <h4> {{$t('Home.bloc3.chappy-block3-title')}} </h4>
                                    <p>
                                        {{$t('Home.bloc3.chappy-block3-content')}}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Section Desc End Here -->
        <!--Section Genesis Start Here -->
        <section class="section-genesis">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 text-center section-genesis__caption">
                        <h2>{{$t('Home.bloc4.title')}}</h2>
                        <p>
                            {{$t('Home.bloc4.content1')}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="genesis__steps">
                <div class="container">
                    <div class="genesis__block clearfix">
                        <div class="genesis__text">
                            <h4>{{$t('Home.bloc4.genese-block1-title')}}</h4>
                            <p>
                                {{$t('Home.bloc4.genese-block1-content1')}}<br />										
                                {{$t('Home.bloc4.genese-block1-content2')}}
                            </p>
                        </div>
                        <div class="genesis__img">
                            <img src="static/img/art1.png" alt="" />
                        </div>
                    </div>
                    <div class="genesis__block clearfix">
                        <div class="genesis__text genesis__text--modifier">
                            <h4>{{$t('Home.bloc4.genese-block2-title')}}</h4>
                            <p>
                                {{$t('Home.bloc4.genese-block2-content1')}}<br />										
                                {{$t('Home.bloc4.genese-block2-content2')}} 
                            </p>
                        </div>
                        <div class="genesis__img genesis__img--modifier">
                            <img src="static/img/art2.png" alt="" />
                        </div>
                    </div>
                    <div class="genesis__block clearfix">
                        <div class="genesis__text">
                            <h4>{{$t('Home.bloc4.genese-block3-title')}}</h4>
                            <p>
                                {{$t('Home.bloc4.genese-block3-content')}}
                            </p>
                        </div>
                        <div class="genesis__img">
                            <img src="static/img/art3.png" alt="" />
                        </div>
                    </div>
                    <div class="genesis__block clearfix">
                        <div class="genesis__text genesis__text--modifier">
                            <h4>{{$t('Home.bloc4.genese-block4-title')}}</h4>
                            <p>
                                {{$t('Home.bloc4.genese-block4-content')}}
                            </p>
                        </div>
                        <div class="genesis__img genesis__img--modifier">
                            <img src="static/img/art4.png" alt="" />
                        </div>
                    </div>
                    <ul>
                        <li>
                            &nbsp;
                        </li>
                        <li>
                            &nbsp;
                        </li>
                        <li>
                            &nbsp;
                        </li>
                        <li>
                            &nbsp;
                        </li>
                        <li>
                            T
                        </li>
                    </ul>
                    <div class="chaperon-bird">
                        <img src="static/img/art5.png" alt="" />
                        <span>{{$t('Home.bloc4.motto')}}</span>
                    </div>
                </div>
            </div>
        </section>
        <!--Section Genesis End Here -->
        <!--Section Slider Start Here -->
        <section class="slider text-center" id="influenceur">
            <div class="container" >
                        <h2>{{$t('Home.bloc6.title')}}</h2>
                        <div class="slider__item font-white">


                            <carousel :autoplay="true" :autoplayHoverPause="true" :loop="true" :perPageCustom="[[1199, 3],[320, 2]]" :centerMode="true">
                                <slide>
                                    <div class="slider__item__block text-center">
                                        <h5><a href="https://www.instagram.com/s/aGlnaGxpZ2h0OjE4MDcyNDU2NTQxMDc5NTE5?igshid=12onm13w9l7ew" target="_blank">@ALICECATDESIGN</a></h5>
                                    </div>
                                </slide>
                                <slide>
                                    <div class="slider__item__block text-center">
                                        <h5><a href="https://www.instagram.com/s/aGlnaGxpZ2h0OjE3ODYyMTIzNTQ0NDQ4NTc5?igshid=18jedjpsm4cq5" target="_blank">@DEPONTEARNAUD</a></h5>
                                    </div>     
                                </slide>
                                <slide>
                                    <div class="slider__item__block text-center">
                                        <h5><a href="https://www.instagram.com/s/aGlnaGxpZ2h0OjE3ODcyNjgwODgzMzk4NTg5?igshid=htcmof3n7v8s" target="_blank">@DAILYLIVESOF.S</a></h5>
                                    </div>
                                <!--
                                    <div class="slider__item__block text-center">
                                        <a href="https://www.instagram.com/s/aGlnaGxpZ2h0OjE3ODcyNjgwODgzMzk4NTg5?igshid=htcmof3n7v8s" target="_blank"><img class="rounded-image img-responsive" src="https://scontent-cdg2-1.cdninstagram.com/v/t51.12442-15/e35/c0.292.750.750a/s150x150/64899077_479001989526105_8483140929787155081_n.jpg?_nc_ht=scontent-cdg2-1.cdninstagram.com&_nc_cat=109&_nc_ohc=U7MxEGg8ZEYAX-ItLXG&oh=6cd6da644ef2d754bab02115fc95402d&oe=5E5EDAB2" alt="@DAILYLIVESOF.S's profile picture"></a>
                                        <br><br>
                                    </div>
                                    <h5>@DAILYLIVESOF.S</h5>
                                -->
                                </slide>
                                <slide>
                                    <div class="slider__item__block text-center">
                                        <h5><a href="https://www.instagram.com/s/aGlnaGxpZ2h0OjE4MDUyNzc1NTQyMDg3Mjc0?igshid=y1f433kbq9yi" target="_blank">@GREGRAW1</a></h5>
                                    </div>
                                </slide>
                                <slide>
                                    <div class="slider__item__block text-center">
                                        <h5><a href="https://www.instagram.com/s/aGlnaGxpZ2h0OjE4MDQ3MDkxNjQzMTgwOTY5?igshid=sxaeo0skf99s" target="_blank">@ONLYBRIGHTNESS</a></h5>
                                    </div>
                                </slide>
                                <slide>
                                    <div class="slider__item__block text-center">
                                        <h5><a href="https://www.instagram.com/stories/highlights/18087351241006832/" target="_blank">@LILYS_FAIRY_TOUCH</a></h5>
                                    </div>
                                    
                                </slide>
                                <slide>
                                    <div class="slider__item__block text-center">                                        
                                        <h5><a href="https://www.instagram.com/stories/highlights/18077528218107197/" target="_blank">@LOXILAUX</a></h5>
                                    </div>
                                </slide>
                            </carousel>
                	    </div>
                <p class="font-white">
                    {{$t('Home.bloc6.content1')}}
                </p>
            </div>
        </section>
        <!--Section Slider End Here -->
        <!--Section Partner Start Here -->
        <section class="section-partners text-center" id="quizz">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 section-genesis__caption">
                        <h2>{{$t('Home.bloc5.title')}}</h2>
                        <p>
                        {{$t('Home.bloc5.content1')}}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 ">
                        <button class="btn-purple btn-lg" type="button" @click="goToQuizz(2)"><i class="fa fa-female"></i>&nbsp;{{$t('Home.bloc5.quizz-woman')}}</button>
                    </div>

                    <div class="col-sm-6 ">
                        <button class="btn-purple btn-lg" type="button" @click="goToQuizz(1)"><i class="fa fa-male"></i>&nbsp;{{$t('Home.bloc5.quizz-man')}}</button>
                    </div>
                </div>
                <!--
                <div class="row ">
                    <div class="col-sm-3">&nbsp;</div>
                    <div class="form-and-links-container col-sm-6 ">-->
                        <!-- Subscription form --><!--
                        <div class="row">
                            <div class="subscription-form-o col-md-12" id="subscription-form" novalidate>
                                <div class="input-group col-xs-10 col-xs-offset-1 col-sm-10 col-sm-offset-0">-->
                                    <!--<input type="email" class="subscription-form-email form-control"  v-validate="'email'" v-model="user.email" name="email" placeholder="Entre ton email pour être tenu informé(e)">--><!--
                                    <span >-->
                                        <!--<button class="subscription-form-submit btn btn-danger" v-on:click="sendMail" :disabled="loading || errors.has('email') || user.email === ''">GO</button>--><!--
                                        <a href="https://chaperon-app.typeform.com/to/u7PNGH" class="btn btn-danger btn-lg" target="_blank">JE PARTICIPE</a>
                                    </span>
                                </div>
                            </div>
                        </div>-->
                        <!-- /Subscription form --><!--
                    </div>
                    <div class="col-sm-3">&nbsp;</div>
                </div>-->
            </div>
        </section>
        <!--Section Partner End Here -->
    </div>
    <!--content End -->
<!--
                    <vue-instagram token="6125564526.1677ed0.a5e35a72782b4bf4b0510becb40291fe" :count="3"  mediaType="image">
                        <template slot="feeds" slot-scope="props">
                            <div class="col-md-4">
                                <div class="preview-card">
                                    <a :href="props.feed.link" target="_blank">
                                        <img :src="props.feed.images.low_resolution.url" alt="Image">
                                    </a>
                                    <h4 class="preview-title">{{ props.feed.caption.text }}</h4>
                                </div>
                            </div>
                        </template>
                        <template slot="error" slot-scope="props">
                            <div class="fancy-alert"> {{ props.error.error_message }} </div>
                        </template>
                    </vue-instagram>
-->

    </div>
    
</template>
<script>
import quizzes from './resources/quizz.json'
export default {
  name: 'home',
  data () {
    return {
      selected: '',
      quizes: quizzes,
      user: {full_name: '', email: '', age: '', job: '', gender: '', q_id: '', from: 'Newsletter'},
      loading: false,
      toast_options: {position: 'bottom-right', duration: 5000, theme: 'primary', type: 'success', action: {text: 'FERMER', onClick: (e, toastObject) => { toastObject.goAway(0) }}}
    }
  },
  mounted () { /*
    this.$contact = this.$resource('messages', {from: 'Chaperon Contact<no-reply@chaperon.me>', to: 'wachiepo@gmail.com', subject: 'New Contact', text: 'Wecome punk', multipart: true}, {}, {
      before: () => { this.loading = true },
      after: () => { this.loading = false }
    })
    */
    this.resource = this.$resource('mailer')
  },
  methods: {
    sendMail: function () {
           // you can call like this in your component
      this.$toasted.show('Envoi en cours...', this.toast_options)
      this.resource.save({}, {user: this.user, result: null}).then(function (response) {
        // you can call like this in your component
        this.$toasted.show('Merci  pour votre participation ! <3', this.toast_options)
        this.loading = true
        console.log('Success!:', response.data)
      }, function (error) {
        this.loading = false
        console.log('Error!:', error)
      })
    },
    goToQuizz: function (selected) {
      if (selected !== '') {
        this.$router.push({path: '/quizz/' + selected})
      }
    }
  }
}
</script>
<style>
.section-quizz .row .col-sm-6{
    padding-bottom: 12px;
}
</style>




// WEBPACK FOOTER //
// Home.vue?d6538c48